<script>
import { mapActions } from "vuex";
import {
	copyObject,
	isValidEmail,
	isValidUsername,
	isValidPassword
} from "@/utils";

export default {
	name: "addUpdateUser",
	props: {
		user: {
			type: Object,
			required: false,
			default: () => ({
				_key: null,
				firstName: "",
				lastName: "",
				username: "",
				email: "",
				phone: "",
				password: ""
			})
		}
	},
	data() {
		return {
			showAddUpdateUser: false,
			showPassword: false,
			errorMessage: "",
			isFormValid: false,
			rules: {
				required: v => !!v || "Required",
				email: v => v && isValidEmail(v) ? true : "Invalid email",
				username: v => v && isValidUsername(v) ? true : "Invalid username",
				password: v => v ? (isValidPassword(v) || "Password must be at least 12 characters long, and contain at least lowercase letter, one number, a special character and one uppercase letter") : true,
			}
		};
	},
	computed: {
		userCopy() {
			return copyObject(this.user);
		}
	},
	methods: {
		...mapActions("users", ["addNewUser", "updateUser"]),
		...mapActions("notification", ["showNotification"]),
		addUpdateUser() {
			this.errorMessage = "";
			if (this.userCopy._key) {
				this.updateUser({ _key: this.userCopy._key, user: this.userCopy })
					.then(() => {
						this.showAddUpdateUser = false;
						this.showNotification({ notificationText: `User ${ this.userCopy.username } updated` });

					})
					.catch(err =>  this.errorMessage = err);
			} else {
				this.addNewUser(this.userCopy)
					.then(() => {
						this.showAddUpdateUser = false;
						this.showNotification({ notificationText: `New user ${ this.userCopy.username } added` });
					})
					.catch(err => err.status === 409 ? this.errorMessage = "Username already exists" : "Saving user failed.");
			}
		},
		closeDialog() {
			if (!this.userCopy._key) {
				this.$refs.form.reset();
			}
		}
	}
};
</script>

<template>
	<v-dialog
		v-model="showAddUpdateUser"
		width="600"
		@input="v => v || closeDialog()"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-icon
				v-if="!userCopy._key"
				v-bind="attrs"
				v-on="on"
				@click="showAddUpdateUser = !showAddUpdateUser"
			>
				mdi-plus
			</v-icon>
			<v-icon
				v-else
				v-bind="attrs"
				v-on="on"
				@click="showAddUpdateUser = !showAddUpdateUser"
			>
				mdi-pencil
			</v-icon>
		</template>
		<v-card>
			<v-form
				@submit.prevent="addUpdateUser"
				v-model="isFormValid"
				ref="form"
			>
				<v-card-title>
					<v-icon large>mdi-account-plus</v-icon>
					{{ userCopy._key ? "Update User" : "New User"}}
				</v-card-title>
				<v-card-text>
					<p
						v-if="errorMessage"
						class="warning--text"
					>{{ errorMessage }}</p>

					<v-text-field
						label="Firstname"
						v-model="userCopy.firstName"
						outlined
					/>
					<v-text-field
						label="Lastname"
						v-model="userCopy.lastName"
						outlined
					/>
					<v-text-field
						label="Username"
						v-model="userCopy.username"
						:rules="[rules.required, rules.username]"
						outlined
					/>
					<v-text-field
						label="Email address"
						v-model="userCopy.email"
						:rules="[rules.required, rules.email]"
						outlined
					/>
					<v-text-field
						label="Phone number"
						v-model="userCopy.phone"
						outlined
					/>
					<v-text-field
						label="Password"
						v-model="userCopy.password"
						hint="At least 12 characters, uppercase, lowercase and special character"
						:rules="[rules.password]"
						:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
						:type="showPassword ? 'text' : 'password'"
						@click:append="showPassword = !showPassword"
						outlined
					/>
				</v-card-text>
				<v-card-actions>
						<v-spacer/>
						<v-btn
							text
							type="submit"
							:disabled="!isFormValid"
						>
							Submit
						</v-btn>
						<v-btn
							text
							type="button"
							@click="showAddUpdateUser = false"
						>
							Cancel
						</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>

<style scoped lang="scss">
.v-card__title, .v-card__actions {
	background-color: #f2f2f2;
}
.v-card__title {
	border-bottom: 1px solid #e6e6e6;
	margin-bottom: 16px;
	i {
		margin-right: 5px;
	}
}
.v-card__actions {
	border-top: 1px solid #e6e6e6;
}
</style>


// WEBPACK FOOTER //
// src/components/elements/AddUpdateUser.vue